import {
  getBackgroundHref,
  hasModalParam,
  hrefTargetsPath,
} from '../utils/modal-routes';
import { useRouter } from './use-router';

import { useCallback } from 'react';

type Options = {
  /**
   * Background href (or sub-path) that must not be restored — e.g. the page of
   * a resource that was just deleted. Falls back to `fallbackHref` instead.
   */
  staleBackgroundHref?: string;
};

export function useCloseModalOrNavigate(
  fallbackHref: string,
  { staleBackgroundHref }: Options = {},
) {
  const router = useRouter();

  return useCallback(() => {
    const backgroundHref = getBackgroundHref();
    const closeToBackground =
      hasModalParam() &&
      !(
        staleBackgroundHref &&
        hrefTargetsPath(backgroundHref, staleBackgroundHref)
      );

    router.replace(closeToBackground ? backgroundHref : fallbackHref, {
      modal: false,
      preventScrollReset: true,
    });
  }, [fallbackHref, router, staleBackgroundHref]);
}
